import {ReferenceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_REFERENCE';

export async function deleteReference(userData: Record<string, string>, id: string) {
    try {
        const result = await ReferenceDao.deleteReference(userData.userToken, id);

        return result;
    }

    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la suppression de l\'affaire',
            error: error
        });
    }
}
